var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('TextSettingsMobile',_vm._g(_vm._b({},'TextSettingsMobile',_vm.textSettingsProps,false),_vm.textSettingsEmits)):_c('TextSettingsDesktop',_vm._g(_vm._b({},'TextSettingsDesktop',_vm.textSettingsProps,false),_vm.textSettingsEmits))
}
var staticRenderFns = []

export { render, staticRenderFns }